//
//  Toggle In View
//
//////////////////////////////////////////////////////////////////////
// Based on https://alligator.io/js/intersection-observer/
//////////////////////////////////////////////////////////////////////

const ToggleInView = () => {
    
  const animIn = document.querySelectorAll('.js-anim-in');
  const isVisibleClass = '--is-visible';

  const config = {
    rootMargin: '-30px 0px',
    threshold: 0
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        
        setTimeout(function () {
          entry.target.classList.add(isVisibleClass);
        }, (100 * entries.indexOf(entry))+ 50);

        observer.unobserve(entry.target);
      } else {
        
      }
    });
  }, config);

  animIn.forEach(item => {
    observer.observe(item);
  });
}

export default ToggleInView;